import { createResource } from "@evergis/react-fetching";
import { GetFeaturesParametersDc, GetFilteredFeaturesCountParams } from "@evergis/api";

import { api as evergisApi } from "../evergis/api";

export const features = createResource(
  ({ layerName, params }: { layerName: string; params: GetFeaturesParametersDc }) =>
    async api => ({
      data: layerName ? await api.layers.getFeatures(layerName, params) : null,
    }),
  {
    injected: evergisApi,
  },
);

export const featuresCount = createResource(
  (params: GetFilteredFeaturesCountParams) => async api => ({
    data: !params?.name ? 0 : await api.layers.getFilteredFeaturesCount(params),
  }),
  {
    injected: evergisApi,
  },
);

export const featuresCountPost = createResource(
  ({ layerName, condition }: { layerName: string; condition?: string }) =>
    async api => ({
      data: await api.layers.getFilteredFeaturesCount1(layerName, { condition }),
    }),
  {
    injected: evergisApi,
  },
);
